
import Vue from 'vue';
export default Vue.extend<any, any, any, any>({
  name: 'Statusbar',
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set which step has been reached
     */
    step: {
      type: Number,
      default: 1
    },
    /**
     * Set total of steps
     */
    totalStep: {
      type: Number,
      default: 4
    },
    /**
     * Set steps label <br />
     * Model of the list: <br />
     * - id: an unique identifier. <br />
     * - label: label of the step.
     */
    stepLabel: {
      type: Array,
      default: () => []
    }
  }
});
